import { useQuery } from '@tanstack/react-query';
import { ListApi } from '@apply/api';
import { applicationInsights } from '../../../../../../../../../../ApplicationInsights';

const listApi = new ListApi.ListApi(applicationInsights);

/** BFI employees (key + name), for the POC and Underwriter dropdowns. Fields sharing it share one request and cache. */
export function useBfiEmployeesQuery() {
    return useQuery({
        queryKey: ['bfiEmployees'],
        queryFn: () => listApi.getBfiEmployees(),
        // The employee list doesn't change while the app is open
        staleTime: Infinity,
    });
}
